import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { experience } from '../content/portfolio';
import Reveal from './Reveal';

/** One table, one type size per row; the three fixed column starts do the organising. */
const Experience: React.FC = () => {
  const { language } = useLanguage();
  const c = experience[language];

  return (
    <section id="experience" data-ink="#e8e6e1" data-field="#0c0b09" className="bg-code-bg py-24 text-code-text sm:py-32">
      <div className="container-responsive">
        <Reveal>
          <h2 className="max-w-3xl font-serif text-4xl font-medium sm:text-5xl">{c.title}</h2>
        </Reveal>
        <Reveal delay={0.08}>
          <p className="mt-5 max-w-2xl text-xl leading-snug">{c.intro}</p>
        </Reveal>

        <ol className="mt-20 space-y-20">
          {c.jobs.map((job) => (
            <li key={job.company + job.period}>
              <Reveal>
                <div className="grid gap-x-8 gap-y-1 md:grid-cols-[33%_1fr_auto]">
                  <h3 className="font-serif text-3xl leading-tight">{job.company}</h3>
                  <p className="text-xl md:pt-2">{job.role}</p>
                  <p className="text-xl text-code-comment md:pt-2 md:text-right">{job.period}</p>
                </div>
                <div className="mt-6 md:ml-[33%] md:max-w-3xl">
                  <p className="text-code-comment">{job.context}</p>
                  <ul className="mt-5 space-y-3 text-xl leading-snug">
                    {job.did.map((line) => (
                      <li key={line}>{line}</li>
                    ))}
                  </ul>
                  <p className="mt-5 text-code-comment">{job.stack.join(', ')}</p>
                </div>
              </Reveal>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default Experience;
